import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import { sortLayers } from './sortShelfLayers';

function shelfChildSortByPosition(shelf: CubeId): void {
    let shelfCube: CubeNode = CubeTree.findByCubeId(shelf);
    let children: Array<CubeId> = CubeTree.findChildCubeIds(shelf);
    let startSort: Array<CubeId> = [];
    let endSort: Array<CubeId> = [];
    let temp: Array<FreeObjMap> = children.map((cubeId: CubeId): FreeObjMap => {
        startSort.push(cubeId);

        return {
            cubeId,
            posY: Utils.toNumber(CubeTree.getNumberValue(cubeId, 'posY')),
            posX: Utils.toNumber(CubeTree.getNumberValue(cubeId, 'posX'))
        };
    });
    let sortTemp: Array<FreeObjMap> = sortLayers(temp);
    let childrenValue: Array<CubeNode> = CubeTree.findCubeChildKey(shelf);

    sortTemp.forEach((sortInfo: FreeObjMap): void => {
        endSort.push(sortInfo.cubeId);
    });

    // 顺序未发生变化，dom不需要重排
    if (startSort.join(',') === endSort.join(',')) {
        return;
    }

    for (let i = sortTemp.length - 1; i >= 0; i--) {
        let cube: CubeNode = CubeTree.findByCubeId(sortTemp[i].cubeId);

        childrenValue.pop();
        childrenValue.unshift(cube);
        shelfCube.jView.find(`.${shelfCube.dslot}`).prepend(cube.jView);
    }
}

export {
    shelfChildSortByPosition
};
